import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[requiredField]'
})
export class RequiredFieldDirective implements OnInit, OnDestroy {
    protected readonly DEBUG: boolean = !environment.production;
    protected timer: any = null;

    constructor(
        private el: ElementRef,
        @Optional() private control: NgControl
    ) {}

    ngOnInit() {
        this.updateStyle();
    }

    ngOnDestroy() {
        this.timer && clearTimeout(this.timer);
    }

    @Input('requiredFieldAttribute') requiredFieldAttribute: string = 'id';
    @Input('requiredFieldClass') requiredFieldClass: string = 'required';
    @Input('requiredFieldCustomControl') customControl: AbstractControl | null = null;


    @HostListener('input') onInput() {
        this.updateStyle();
    }

    private updateStyle() {
        this.timer && clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            try {
                const isRequired = this.control?.name
                    ? !!(this.control.control?.validator && this.control.control.validator({} as any)?.['required'])
                    : this.customControl
                        ? !!(this.customControl?.validator && this.customControl.validator({} as any)?.['required'])
                        : false;

                const inputElement = this.el.nativeElement;
                const selector = 'label[for=' + (inputElement.getAttribute(this.requiredFieldAttribute) ?? this.requiredFieldAttribute) + ']';
                const labelElement = inputElement.closest('form')?.querySelector(selector) ?? document?.querySelector(selector);
                // const isRequired = !!(this.control.control?.validator && this.control.control.validator({} as any)?.['required']);
                labelElement?.classList.toggle(this.requiredFieldClass, isRequired);

            } catch (e) {
                this.DEBUG && console.log("requiredField", e);
            }
        }, 10);
    }
}
